
































import { Component, Mixins, Prop } from 'vue-property-decorator'
import SalesReportMixin from '@/views/Reports/Report/SalesReport/SalesReportMixin'

@Component
export default class TurnoverCurrentYearInformation extends Mixins(SalesReportMixin) {
    @Prop({ required: true }) type!: string
}
